import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { ExclusionsListService } from 'src/app/services/exclusions-list.service';
import { ExclusionList } from 'src/app/models/exclusion-list';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { CommonModule } from '@angular/common';
import { GlidePathChartComponent } from "./target-date-performance/glide-path-chart/glide-path-chart.component";
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-target-date',
    templateUrl: './target-date.component.html',
    styleUrls: ['./target-date.component.scss'],
    imports: [SafePipe, CommonModule, GlidePathChartComponent,RouterModule]
     
})
export class TargetDateComponent implements OnInit {

  title = "Investing for Catholics Target Retirement Index Portfolios";

  exclusions!: ExclusionList[]

  constructor( private seoservice: SeoService, private meta: Meta, private exlusionservice: ExclusionsListService, private cdr: ChangeDetectorRef, @Inject(PLATFORM_ID) private platformId: Object) {

    this.exlusionservice.getExclusionsList().subscribe(resp => {
   
      //removes first article from header
      this.exclusions = resp;
      this.cdr.detectChanges();
   
    })
// $&(this.exclusions)

   }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'target date retirement portfolios, catholic portfolio exemption list, socially responsible investing'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Target Retirement Index Portfolios.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

  scrollTo(id: string, event: Event) {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }

}
